module.exports = __webpack_public_path__ + "img/confirm.8e5552d8.svg";